import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/billing-terms/new/loading';

export const Route = createFileRoute('/_private/settings/billing-terms/new')({
  component: Loading,
});
